
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shipId]",
      function () {
        return require("private-next-pages/[shipId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shipId]"])
      });
    }
  